// extracted by mini-css-extract-plugin
var _1 = "ProfileLabelsWidgetItem-moduleProfileLabelsWidgetItem__DLLDQ";
export { _1 as "ProfileLabelsWidgetItem" }
